import React from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';


const getHighestLevelLabels = (participationType) => {
    return {
        5: 'International',
        4: 'National',
        3: 'State/ Regional',
        2: 'District/ Local',
        1: 'School/City',
    };
};

const outcomeLabels = {
    5: 'Well above average',
    4: 'Above average',
    3: 'Average',
    2: 'Below Average',
    1: 'NA',
};

const enjoymentLabels = {
    3: 'Enjoyed ',
    2: 'Neutral',
    1: 'Didn’t Enjoy',
};

const activityTypeLabels = {
    3: 'Team Leader ',
    2: 'Team Member',
    1: 'Individual Contributor',
};


const TableActivityComponent = ({ data, handleActivityDelete }) => {
    return (
        < div >
            <TableContainer component={Paper} style={{ borderRadius: "12px", marginTop: '20px', fontFamily: 'Poppins, sans-serif' }}>
                <Table>
                    <TableHead style={{ background: '#2560CD' }}>
                        <TableRow>
                            <TableCell
                                style={{
                                    color: 'white',
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '15px',
                                    border: '2px solid white'
                                }}
                            >
                                Activity
                            </TableCell>
                            <TableCell
                                style={{
                                    color: 'white',
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '15px',
                                    border: '2px solid white'
                                }}
                            >
                                Participation Type
                            </TableCell>
                            <TableCell
                                style={{
                                    color: 'white',
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '15px',
                                    border: '2px solid white'
                                }}
                            >
                                Participation Level
                            </TableCell>
                            <TableCell
                                style={{
                                    color: 'white',
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '15px',
                                    border: '2px solid white'
                                }}
                            >
                                Performance
                            </TableCell>
                            <TableCell
                                style={{
                                    color: 'white',
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '15px',
                                    border: '2px solid white'
                                }}
                            >
                                Role Type
                            </TableCell>
                            <TableCell
                                style={{
                                    color: 'white',
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '15px',
                                    border: '2px solid white'
                                }}
                            >
                                Enjoyed
                            </TableCell>
                            <TableCell
                                style={{
                                    color: 'white',
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '15px',
                                    border: '2px solid white'
                                }}
                            >
                                {' '}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((activity, index) => {
                            const highestLevelLabels = getHighestLevelLabels(activity.participationType);
                            return (
                                <TableRow key={index} style={{ background: '#2C3A841A', fontFamily: 'Poppins, sans-serif' }}>
                                    <TableCell style={{ border: '2px solid white' }}>{activity.activity}</TableCell>
                                    <TableCell style={{ border: '2px solid white' }}>{activity.participationType}</TableCell>
                                    <TableCell style={{ border: '2px solid white' }}>{highestLevelLabels[activity.highestLevel]}</TableCell>
                                    <TableCell style={{ border: '2px solid white' }}>{outcomeLabels[activity.outcome]}</TableCell>
                                    <TableCell style={{ border: '2px solid white' }}>{activityTypeLabels[activity.activityType]}</TableCell>
                                    <TableCell style={{ border: '2px solid white' }}>{enjoymentLabels[activity.enjoyment]}</TableCell>
                                    <TableCell style={{ border: '2px solid white' }}>
                                        <IconButton aria-label="remove" onClick={() => handleActivityDelete(index, activity.activityId)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div >

    )
}

export default TableActivityComponent;